export const projects = [
  {
    title: "Riffin",
    description:
      "Riffin takes the hassle out of writing tablature so you can focus on capturing the music. Simply click anywhere on the staff to start writing. No pesky dashes, no cumbersome software. Let your creativity flow with Riffin.io. I redesigned and optimized the entire backend and databased. I continue to work on front-end design and integration, as well as making any necessary changes to the backend. [Version 1 will be launching soon!]",
    img: "./img/riffin.PNG",
    repositoryLink: "https://github.com/dabyzness/tot-front-end",
    deploymentLink: "https://tots-hot-tots.netlify.app/",
    stack: [
      "react",
      "javascript",
      "express",
      "mongodb",
      "mui",
      "nodejs",
      "bootstrap",
      "html5",
      "css3",
    ],
  },
  {
    title: "Amass",
    description:
      "Amass is an all-in-one real estate application for new or small-time owners and their tenants. It is a comprehensive software solution designed to assist individuals who are entering the real estate market or managing a small portfolio of properties. This application aims to streamline various aspects of property ownership, providing users with tools and resources to simplify their tasks and maximize their efficiency. [This project is currently on hold for development]",
    img: "./img/amass.PNG",
    repositoryLink: "https://github.com/dabyzness/tot-front-end",
    deploymentLink: "https://tots-hot-tots.netlify.app/",
    stack: [
      "react",
      "javascript",
      "express",
      "mongodb",
      "mui",
      "nodejs",
      "bootstrap",
      "html5",
      "css3",
    ],
  },
  {
    title: "ToT",
    description:
      "Tot, or Taste of TikTok for long, is a MERN web app for users who want to track and display restaurants, bars, and other lifestyle locations that they found through TikTok. It's essentially if Yelp and Tiktok merged. In order to save a tiktok video to the your page, simply copy and paste the URL of the video and Tot will do the rest. You can even play your own videos or play through the countless others that Totheads have uploaded -- no need to switch apps to watch on TikTok! [Mobile-Only Design]",
    img: "./img/tot.png",
    repositoryLink: "https://github.com/dabyzness/tot-front-end",
    deploymentLink: "https://tots-hot-tots.netlify.app/",
    stack: [
      "react",
      "javascript",
      "express",
      "mongodb",
      "mui",
      "nodejs",
      "bootstrap",
      "html5",
      "css3",
    ],
  },
  {
    title: "Plantra",
    description:
      "Welcome to Plantra, a place to track and share your plants with the world. Set a watering schedule for your plants, check your calendar to see which plants you have to water, upload pictures of your plants and keep track of it's growth! View what others are posting and like and comment to see their plant collection! [Mobile-Only Design]",
    img: "./img/plantra.png",
    repositoryLink: "https://github.com/dabyzness/plantra",
    deploymentLink: "https://plantra.fly.dev/",
    stack: [
      "javascript",
      "express",
      "mongodb",
      "nodejs",
      "bootstrap",
      "html5",
      "css3",
    ],
  },
  {
    title: "Pacman",
    description:
      "The goal of this project was to create a clone of Midway Manufacturing's 1980 arcade classic Pacman. You play as the yellow, gluttonous menace, Pacman, whose only goal is to gobble up all of the snack pellets on the board -- but it's not as easy as it seems. You'll have to avoid a pack of ghosts chasing after you, one wrong move and it's game over. Do you have what it takes to outsmart them and swallow up all the pellets?",
    img: "./img/pacman.png",
    repositoryLink: "https://github.com/dabyzness/pacman",
    deploymentLink: "https://pacman-alpha.netlify.app/",
    stack: ["javascript", "bootstrap", "html5", "css3"],
  },
  {
    title: "Tic-Tac-Pro",
    description:
      "This is a spin-off on the classic Tic-Tac-Toe game. There are three different versions that you can play: Toe, Pro, and No. Toe is the original Tic-Tac-Toe. Pro expands on the original by creating a 3x3 grid of the original 3x3 game, in total creating a 9x9 grid. The square in which the next allowable move may be placed is determined by the the preceding move. Plan accordingly to stumble your opponents next move! And finally, No is just the original game with a twist -- You'll never be able to win!",
    img: "./img/TTT-pro.PNG",
    repositoryLink:
      "https://github.com/dabyzness/ttt-weekend/tree/main/version2",
    deploymentLink: "https://tic-tac-toe-pro-no.netlify.app",
    stack: ["javascript", "html5", "css3"],
  },
  // {
  //   title: "Current",
  //   description:
  //     "A time management methodology that incorporates the rigidity of time blocking into our hectic and chaotic days. It allows users to take a more flexible approach to goal setting and time management while sticking to a predetermined schedule. Additionally, it allows for leaving notes and reminders to automatically appear the next time the task is repeated. It also allows for periods of reflection. Thi",
  //   img: "./img/swift.png",
  //   repositoryLink: "https://github.com/dabyzness/tot-front-end",
  //   deploymentLink: "https://tots-hot-tots.netlify.app/",
  //   stack: [
  //     "react",
  //     "javascript",
  //     "express",
  //     "mongodb",
  //     "mui",
  //     "nodejs",
  //     "bootstrap",
  //     "html5",
  //     "css3",
  //   ],
  // },
];
